export const timesheetRecordStatusOptions: {name: string, value: string, icon: string}[] = [
  {
    name: '',
    value: 'auto',
    icon: '',
  },
  {
    name: 'pending-confirmation',
    value: 'manual',
    icon: 'pi pi-exclamation-triangle',
  },
  {
    name: 'confirmed',
    value: 'confirmed',
    icon: 'pi pi-check-square',
  },
];